import {
  AnyFeature,
  PrimaryFeature,
  SecondaryFeature,
  TertiaryFeature,
} from '../../utils/types';
import { GlobalFilterType } from './GlobalFilters';

export const disabledFilters = new Map<AnyFeature, GlobalFilterType[] | null>([
  [PrimaryFeature.REPORTING, []],
  [SecondaryFeature.REPORTING_SALES, []],
  [SecondaryFeature.REPORTING_TARGETS, [GlobalFilterType.PORTFOLIOS]],
  [SecondaryFeature.REPORTING_OPPORTUNITIES, []],
  [SecondaryFeature.REPORTING_LEADS, []],
  [SecondaryFeature.REPORTING_PRODUCT_SAMPLES, []],
  [SecondaryFeature.REPORTING_SUPPLY_CHAIN, [GlobalFilterType.MARKET_SEGMENTS]],
  [SecondaryFeature.REPORTING_INCIDENTS, [GlobalFilterType.MARKET_SEGMENTS]],

  [
    SecondaryFeature.LABS_AND_FORMULATIONS_FORMULATIONS,
    [GlobalFilterType.COUNTRIES, GlobalFilterType.TERRITORIES],
  ],

  [PrimaryFeature.INSIGHTS, []],
  [SecondaryFeature.INSIGHTS_PRODUCT_FEEDBACK, []],
  [
    SecondaryFeature.INSIGHTS_MARKET_INSIGHTS,
    [GlobalFilterType.PORTFOLIOS, GlobalFilterType.TERRITORIES],
  ],
  [
    SecondaryFeature.INSIGHTS_SOCIAL_LISTENING,
    [
      GlobalFilterType.COUNTRIES,
      GlobalFilterType.TERRITORIES,
      GlobalFilterType.MARKET_SEGMENTS,
      GlobalFilterType.PORTFOLIOS,
    ],
  ],
  [
    SecondaryFeature.INSIGHTS_EXPANSION_OPPORTUNITIES,
    [
      GlobalFilterType.COUNTRIES,
      GlobalFilterType.TERRITORIES,
      GlobalFilterType.MARKET_SEGMENTS,
      GlobalFilterType.PORTFOLIOS,
    ],
  ],
  [
    TertiaryFeature.INSIGHTS_CUSTOMER_PORTAL_INSIGHTS_PRODUCT_VIEWS,
    [GlobalFilterType.PORTFOLIOS],
  ],
  [
    TertiaryFeature.INSIGHTS_CUSTOMER_PORTAL_INSIGHTS_MY_SUPPLIER_PAGE,
    [
      GlobalFilterType.COUNTRIES,
      GlobalFilterType.TERRITORIES,
      GlobalFilterType.MARKET_SEGMENTS,
      GlobalFilterType.PORTFOLIOS,
    ],
  ],
] as [AnyFeature, GlobalFilterType[] | null][]);

export function showGlobalFilters(
  secondaryFeature: SecondaryFeature | null,
  tertiaryFeature: TertiaryFeature | null,
): boolean {
  return !!(
    (secondaryFeature && disabledFilters.has(secondaryFeature)) ||
    (tertiaryFeature && disabledFilters.has(tertiaryFeature))
  );
}

export function getDisabledGlobalFilters(
  secondaryFeature: SecondaryFeature | null,
  tertiaryFeature: TertiaryFeature | null,
): GlobalFilterType[] {
  return (
    (secondaryFeature && disabledFilters.get(secondaryFeature)) ??
    (tertiaryFeature && disabledFilters.get(tertiaryFeature)) ??
    []
  );
}
